// Community.tsx (DROP-IN REPLACEMENT)
//
// Goal:
// - Keep Community as its own page (Announcements live here)
// - Chats page no longer needs any "community" switching logic
// - Simple, stable layout: header + optional toolbar + announcement feed + tabs
//
// Notes:
// - Keeps your existing “My Associates” button + badge
// - Leaves a right-side options button placeholder for later
// - Uses your existing AnnouncementFeed component

import React, { useContext } from "react";
import {
  IonPage,
  IonContent,
  IonToolbar,
  IonButtons,
  IonButton,
  IonLabel,
  IonIcon,
  IonBadge,
} from "@ionic/react";
import { optionsOutline, peopleCircleOutline } from "ionicons/icons";

import { WerkerSchedulerHeader } from "../components/WerkHeader";
import TabNavigator from "../components/TabNavigator";
import AnnouncementFeed from "../components/AnnouncementFeed";

import { ProfileContext } from "../context/ProfileContext";
import { HEADERTEXT_TYPES } from "../functions/postActionTypes";

const Community: React.FC = () => {
  const { badgeCountAssociateRequestsContext } = useContext(ProfileContext);

  return (
    <IonPage
    >
      <WerkerSchedulerHeader title={HEADERTEXT_TYPES.Community} />

      <IonContent
        fullscreen
      >
        {/* Top tools row (kept minimal for now) */}
        <IonToolbar
          className="ion-padding-horizontal ion-margin-top"
        >
          <IonButtons
            slot="start"
          >
            <IonButton
              fill="outline"
              routerLink="/associates"
              routerDirection="forward"
            >
              <IonIcon
                slot="start"
                icon={peopleCircleOutline}
              />
              <IonLabel
              >
                My Associates
              </IonLabel>

              {badgeCountAssociateRequestsContext > 0 && (
                <IonBadge
                  color="danger"
                  style={{ marginLeft: 6 }}
                >
                  {badgeCountAssociateRequestsContext}
                </IonBadge>
              )}
            </IonButton>
          </IonButtons>

          <IonButtons
            slot="end"
          >
            <IonButton
              disabled
            >
              <IonIcon
                icon={optionsOutline}
              />
            </IonButton>
          </IonButtons>
        </IonToolbar>

        {/* Main announcement feed */}
        <div style={{ marginTop: 12 }}>
          <AnnouncementFeed />
        </div>
      </IonContent>

      <TabNavigator />
    </IonPage>
  );
};

export default Community;
